import { RigRampStatusBase } from './base/rig-ramp-status-base';

export class RigRampStatus extends RigRampStatusBase { }